const Universities = ['S_No', 'State', 'Type', 'Yrofestab', 'Name', 'Village', 'City', 'District', 'PIN', 'url', 'Phone', 'Email', 'Image', 'Logo', 'Location_Coordinates'];

const Programme = ['SNo', 'ProgrammeType', 'Programme', 'Name', 'Discipline'];

const School = ['SlNo', 'name', 'code', 'estdYr', 'Catagory', 'address', 'Village', 'City', 'pin', 'district', 'state', 'location', 'areaType', 'principal', 'url', 'email', 'phone', 'AffiliationBody', 'AfiliationNumber', 'ClassesFrom', 'ClassesTo', 'Mol', 'streamsOffered', 'AboutSchool', 'facilities', 'events', 'management', 'gender', 'AccStatus', 'schoolArea', 'facultyStrength', 'studentStrength', 'des', 'blogPosts', 'Gallery', "Apply"]

export default {
    Universities,
    Programme,
    School
}